// extracted by mini-css-extract-plugin
export default {"container":"main_container__k8twq","report_section":"main_report_section__LdIIj","btns_section":"main_btns_section__Hj+o0","head_description":"main_head_description__kAWJp"};